
export const TRIP_TYPE_OPTIONS = [
  { value: 'O', title: 'One Way' },
  { value: 'R', title: 'Round Trip' },
];



// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/constants.js